import { z } from 'zod';
import { AllTranslationKeys } from '@anytag/shared-assets';
import { BaseValidations } from '@anytag/shared-validations';

export const ChangePasswordSchema = z
  .object({
    currentPassword: BaseValidations.PasswordSchemaWithRegex,
    password: BaseValidations.PasswordAdvancedSchemaDynamic,
    passwordConfirm: BaseValidations.PasswordAdvancedSchemaDynamic
  })
  .refine(({ password, passwordConfirm }) => password === passwordConfirm, {
    message: AllTranslationKeys.Error.passwordsDoNotMatch,
    path: ['passwordConfirm']
  });
